const rankings = [
  { rank: 1, title: '星辰变', heat: '98.6万', category: '奇幻·热血', status: '连载中', trend: '↑ 2' },
  { rank: 2, title: '偷偷藏不住', heat: '92.3万', category: '恋爱·校园', status: '已完结', trend: '↑ 1' },
  { rank: 3, title: '诡秘之主', heat: '88.7万', category: '悬疑·奇幻', status: '连载中', trend: '↓ 1' },
  { rank: 4, title: '一人之下', heat: '81.4万', category: '热血·都市', status: '连载中', trend: '↑ 3' },
  { rank: 5, title: '某天成为公主', heat: '76.8万', category: '古风·恋爱', status: '已完结', trend: '—' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          人气排行榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          全网漫画人气热度排行，韩漫日漫国漫全本漫画实时榜单
        </p>
        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankings.map((item, idx) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-4 p-4 md:p-5 transition-colors hover:bg-primary-50/50 cursor-pointer ${
                idx !== rankings.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-heading text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.trend}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-sm font-medium text-foreground-900">{item.heat}</div>
                <div className="text-xs text-foreground-500">{item.status}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}